import SlotManager from './SlotManager';

export default SlotManager;
export { SlotManager };
